import React from 'react';
import CheckTable from 'views/admin/customerUsers/components/CheckTable';
const index = () => {
  return (
    <div>
      <CheckTable />
    </div>
  );
};

export default index;
